<template>
    <div class="index">
      <div class="main">
          <div class="box" style="margin-right: 80px">
            <div class="title">联系<span style="color: #FE3B35">方式</span></div>
            <div class="des">CONTACT</div>
            <div class="con">电话：18060733781</div>
          </div>
          <div class="box" style="margin-right: 80px">
            <div class="title">微信<span style="color: #FE3B35">公众号</span></div>
            <div class="des">CONTACT</div>
            <div class="con"><img src="@/assets/img/contactUs/erweima.jpg" alt="" style="width: 166px;height: 166px;"></div>
          </div>
          <div class="box">
            <div class="title">电子<span style="color: #FE3B35">邮箱</span></div>
            <div class="des">CONTACT</div>
            <div class="con">
              招聘：linying@syy333.com <br><br>
              商务：linying@syy333.com
            </div>
          </div>
        </div>
<!--      <img src="@/assets/img/contactUs/bg.png" alt="" style="width: 100%;display: block">-->
      <div class="main" style="height: 660px;background: #fff">
        <div class="box" style="margin-right: 160px">
          <div class="title">公司<span style="color: #FE3B35">地址</span></div>
          <div class="des">ADDRESS</div>
          <div class="con">福建省福州市仓山区金工路28号 <br>捷福产业园4栋5楼D</div>
        </div>
        <iframe style="width: 690px;
height: 443px;" src="https://www.amap.com/search?query=%E4%B8%89%E7%9B%8A%E5%8F%8B(%E7%A6%8F%E5%B7%9E)%E4%BF%A1%E6%81%AF%E6%8A%80%E6%9C%AF%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&city=350100&geoobj=119.249042%7C26.059009%7C119.258062%7C26.064235&zoom=17.5" frameborder="0"></iframe>
      </div>
    </div>
</template>

<script>
    /**
     *
     * @Author zzl
     * @Date 2020/11/20 14:28.
     */

    export default {
        mounted() {

        },
        components: {},
        props: {},
        data() {
            return {}
        },
        computed: {},
        methods: {},
        watch: {},
        filters: {},
        beforeDestroy() {

        }
    }
</script>

<style lang="less" scoped>
.index{
  width: 100%;
  min-width: 1920px;
  .main{
    width: 100%;
    height: 450px;
    padding-top: 90px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background: #ffffff;
    /*background:-webkit-linear-gradient(bottom,#E9E8E9,#FEFBFB);*/
    /*background:-o-linear-gradient(bottom,#E9E8E9,#FEFBFB);*/
    /*background:-moz-linear-gradient(bottom,#E9E8E9,#FEFBFB);*/
    /*background:linear-gradient(to bottom,#E9E8E9,#FEFBFB);*/

    .box{
      width: 400px;
      position: relative;
      .title{
        text-align: center;
        width: 100%;
        position: absolute;
        top: 36px;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #232330;
        z-index: 9;
      }
      .des{
        text-align: center;
        width: 100%;
        top: 0;
        position: absolute;
        font-size: 70px;
        font-family: Source Han Sans CN;
        font-weight: 800;
        color: #F6F6F6;
      }
      .con{
        top: 120px;
        position: absolute;
        text-align: center;
        width: 100%;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #232330;
      }
    }
  }
}
</style>
